import { Checkbox } from "antd";
import React from "react";

interface CheckboxValue {
  value: boolean;
  name: string;
}

interface PreferredContactMethod {
  text: CheckboxValue;
  phone: CheckboxValue;
  email: CheckboxValue;
}

interface QuoteFormPreferredContactProps {
  preferredContactMethod: PreferredContactMethod;
  setPreferredContactMethod: (value: PreferredContactMethod) => void;
}

const QuoteFormPreferredContact = (props: QuoteFormPreferredContactProps) => {
  const { preferredContactMethod, setPreferredContactMethod } = props;

  const getKeyValue = (keyName: string) => {
    switch (keyName) {
      case "text":
        return "text";
      case "phone":
        return "phone";
      case "email":
        return "email";
      default:
        return "phone";
    }
  };

  const changeHandler = (keyname: string, inputValue: boolean) => {
    const keyvalue = getKeyValue(keyname);
    setPreferredContactMethod({
      ...preferredContactMethod,
      [keyvalue]: {
        ...preferredContactMethod[keyvalue],
        value: inputValue,
      },
    });
    return;
  };

  return (
    <div className="m-top-10 flex-col-stretch" style={{alignItems: 'flex-start'}}>
      <span className="text-color-blue fw-500">
        Preferred Contact Method (Check all that apply)<span className="text-color-red">*</span>
      </span>
      <div className="flex-row-nowrap w-100-P text-color-blue" style={{ justifyContent: "space-between" }}>
        {Object.keys(preferredContactMethod).map((keyname) => {
          const keyvalue = getKeyValue(keyname);
          return (
            <Checkbox 
                key={keyname} 
                checked={preferredContactMethod[keyvalue].value} 
                onChange={(e) => changeHandler(keyvalue, e.target.checked)}
            >
              {preferredContactMethod[keyvalue].name}
            </Checkbox>
          );
        })}
      </div>
    </div>
  );
};
export default QuoteFormPreferredContact;
